import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  InjectionToken,
  LOCALE_ID,
  provideExperimentalZonelessChangeDetection,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
} from '@angular/router';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { FilterMatchMode } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';

import '@angular/common/locales/global/de';
import '@angular/common/locales/global/en';
import {
  AUTH_LOGIN_REDIRECT,
  AUTH_STORAGE,
  provideSanctumAuthentification,
  provideXsrfConfiguration,
  sanctumInterceptor,
  xsrfInterceptor,
} from '@freesixtyfive/auth';
import { WA_LOCAL_STORAGE } from '@ng-web-apis/common';
import { provideEchartsCore } from 'ngx-echarts';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';
import { ThemePreset } from './theme-preset';
// import echarts core
import { echarts } from './echarts.config';

export const EnvironmentToken = new InjectionToken<typeof environment>(
  'app.environment',
);

export const appConfig: ApplicationConfig = {
  providers: [
    provideExperimentalZonelessChangeDetection(),
    provideRouter(appRoutes, withEnabledBlockingInitialNavigation()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: ThemePreset,
        options: {
          darkModeSelector: false,
          cssLayer: {
            name: 'primeng',
            order: 'theme, base, primeng',
          },
        },
      },
      filterMatchModeOptions: {
        date: [
          FilterMatchMode.DATE_IS,
          FilterMatchMode.DATE_IS_NOT,
          FilterMatchMode.DATE_BEFORE,
          FilterMatchMode.DATE_AFTER,
          FilterMatchMode.BETWEEN,
        ],
      },
    }),
    provideHttpClient(withInterceptors([xsrfInterceptor, sanctumInterceptor])),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/i18n/',
        suffix: '.json',
      }),
      fallbackLang: 'en',
      lang: 'de',
    }),
    provideXsrfConfiguration({
      requestUrl: `${process.env.FE_API_BASE}/sanctum/csrf-cookie`,
      sendAlways: true,
    }),
    provideSanctumAuthentification({
      signInUrl: `${process.env.FE_API_BASE}/auth/login`,
      signOutUrl: `${process.env.FE_API_BASE}/auth/logout`,
      forgotPwUrl: `${process.env.FE_API_BASE}/api/auth/users/forgotPassword`,
      resetPwUrl: `${process.env.FE_API_BASE}/api/auth/users/resetPassword`,
    }),
    { provide: AUTH_LOGIN_REDIRECT, useValue: '/login' },
    { provide: AUTH_STORAGE, useFactory: () => inject(WA_LOCAL_STORAGE) },
    // { provide: API_BASE, useValue: process.env.FE_API_BASE },
    // { provide: LOCALE_ID, useValue: 'de-DE' },
    { provide: LOCALE_ID, useValue: 'de' },
    { provide: EnvironmentToken, useValue: environment },
    provideEchartsCore({ echarts }),
  ],
};
